export { default as useOutsideClick } from './useOutsideClick';
